/**
 * DatabaseProfile — DBML-style database schema diagrams.
 * See plans/software-design/domain.md § 2 for grammar and relationship subtypes.
 */

import type { DomainDataProfile } from '../../../core/data-profiles';
import type { DiagramType } from '../../../lib/diagram/registries';

export type DatabaseNodeType = 'db_table' | 'db_column' | 'db_enum' | 'db_tablegroup';
export type DatabaseEdgeType = 'db_ref' | 'db_ref_many';

export const DatabaseProfile: DomainDataProfile<DatabaseNodeType, DatabaseEdgeType> = {
  domainId: 'database',
  profileVersion: '1.0',
  diagramTypes: ['database' as DiagramType],
  nodeTypes: ['db_table', 'db_column', 'db_enum', 'db_tablegroup'],
  edgeTypes: ['db_ref', 'db_ref_many'],
  vocabulary: {
    recordSingular: 'Table',
    recordPlural: 'Tables',
    repositoryLabel: 'Database',
    hierarchyLabel: 'References',
    importAction: 'Import Schema',
    keyColumnHint: 'Table Name',
    commitLabel: 'Push Schema',
    pullLabel: 'Refresh Schema',
    diagramLabel: 'database schema',
  },
  fieldAliases: {
    name: ['table', 'tableName'],
    columns: ['fields', 'cols'],
    indexes: ['index', 'idx'],
  },
  requiredProps: ['name'],
  recommendedProps: ['columns', 'indexes'],
  primaryShapeType: 'db_table',
  propsToAttrsMapping: {
    name: 'name',
    columns: 'columns',
    indexes: 'indexes',
    tablegroup: 'tablegroup',
  },
  relationshipPackId: 'software-design-relationships',
};
